export default class LoginForm {

  private username: JQuery;
  private submit: JQuery;
  private parsleyForm: any;

  constructor(private form: JQuery) {
    this.submit = form.find('.js-loginButton');
    this.username = form.find('.js-username');
    this.parsleyForm = form.parsley();
  }

  init(): void {
    this.bindValidateOnSubmit();
  }

  bindValidateOnSubmit() {
    this.form.on('submit', () => {
      this.parsleyForm.validate();
    });
  }

}
